import { render, staticRenderFns } from "./NavbarBack.vue?vue&type=template&id=4af00ee7&scoped=true&"
import script from "./NavbarBack.vue?vue&type=script&lang=js&"
export * from "./NavbarBack.vue?vue&type=script&lang=js&"
import style0 from "./NavbarBack.vue?vue&type=style&index=0&id=4af00ee7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af00ee7",
  null
  
)

export default component.exports